import { defineMessages } from 'react-intl';

export default defineMessages({
    wrongSiteTitle: {
        id: 'wrongSiteMessage',
        defaultMessage: "It looks like you're on the wrong site"
    },
    notInYourCountryTitle: {
        id: 'notInYourCountryMessage',
        defaultMessage: "We're not in your country yet"
    },
    differentCountryMessage: {
        id: 'differentCountryMessage',
        defaultMessage:
            'You need to be a UK resident to use iwoca.co.uk but we have a dedicated site for businesses in {countryLabel}.'
    },
    wrongCountryMessage: {
        id: 'wrongCountryMessage',
        defaultMessage:
            "Unfortunately, iwoca is currently only available in the UK, Germany, Poland and Spain. However, we're growing fast and aim to launch in more countries in the future."
    },
    switchCountryWebsite: {
        id: 'switchCountryWebsite',
        defaultMessage: 'Switch to iwoca.{countryDomain}'
    }
});
